// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5608) return "static/chunks/5608-1edb96e275086d06.js";
	if (chunkId === 8765) return "static/chunks/8765-73b335754a094ef9.js";
	if (chunkId === 9334) return "static/chunks/9334-3f20346fced2ee02.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"292":"f99e07b63e56b45e","3918":"9e4739e940082575","4835":"fafa1744cea536d8","5710":"f85802248b099739","8384":"0453fba636f2fb5e","9907":"e80f9f868402889e"}[chunkId] + ".js";
};